<div class="innerSearchForm">
    <div class="mobileViewHeader">
        <h2>Result</h2>
        <button  mat-button class="modifyBtnMobile" color="primary" (click)="modifierSearchMobile()">Modify</button>
    </div>
    <ng-container>
        <form [formGroup]="flightSearch">
            <div class="formWrapper">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Trip Selection</mat-label>
                    <mat-select [formControl]="trip_selected" (selectionChange)="trip_selected_($event)">
                        <mat-option *ngFor="let item of trip" [value]="item.value">{{item.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <ng-container *ngIf="list.trip_selected !== 2">
                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>From</mat-label>
                        <input  #travelling_from_input matInput [formControl]="travelling_from" placeholder="Enter your Traveller From" [matAutocomplete]="auto" (click)="removeFocus()" (click)="clearSearch(travelling_from)" (blur)="handleBlur()">
                        <mat-autocomplete #auto="matAutocomplete">
                            <div class="flight_search_dropdown">
                                <cdk-virtual-scroll-viewport appendOnly itemSize="10" [style.height.px]="200">
                                    <mat-option *cdkVirtualFor="let item of filteredCities | async" [value]="item.city_name.concat(' ('+ item.airport_code+')')" (click)="selected_form(item)">
                                        <div class="dropdownContent">
                                            <div class="content">
                                                <p class="place">{{item.city_name}}({{item.airport_code}})&nbsp;<img [src]="item.flag" alt="" class="img-fluid flagimg"> </p>
                                                <p class="stateCountry">{{ item.airport_name.length > 24 ? (item.airport_name | slice:0:24) + '...' : item.airport_name }}</p>
                                            </div>
                                        </div>
                                    </mat-option>
                                </cdk-virtual-scroll-viewport>
                                </div>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>To</mat-label>
                        <input  #travelling_to_input matInput [formControl]="travelling_to" placeholder="Enter your Traveller From" [matAutocomplete]="autoTo" (click)="removeFocusTo()"(click)="clearSearch(travelling_to)" (blur)="handleBlurTo()">
                        <mat-autocomplete #autoTo="matAutocomplete">
                            <div class="flight_search_dropdown">
                                <cdk-virtual-scroll-viewport appendOnly itemSize="10" [style.height.px]="200">
                                    <mat-option *cdkVirtualFor="let item of filteredCitiesTo | async" [value]="item.city_name.concat(' (' + item.airport_code + ')')" (click)="selected_to(item)">
                                        <div class="dropdownContent">
                                            <div class="content">
                                                <p class="place">{{item.city_name}}({{item.airport_code}})&nbsp;<img [src]="item.flag" alt="" class="img-fluid flagimg"> </p>
                                                <p class="stateCountry">{{ item.airport_name.length > 24 ? (item.airport_name | slice:0:24) + '...' : item.airport_name }}</p>
                                            </div>
                                        </div>
                                    </mat-option>
                                </cdk-virtual-scroll-viewport>
                            </div>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field appearance="outline" floatLabel="always" (click)="departureDatepicker.open()">
                        <mat-label>Departure Date</mat-label>
                        <input (dateChange)="departureDateChanged($event)" [max]="maxDate" [min]="minDate" matInput [formControl]="onwarddate" [matDatepicker]="departureDatepicker" placeholder="Choose a Date" readonly>
                        <mat-datepicker-toggle matSuffix [for]="departureDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #departureDatepicker startView="month" [panelClass]="'disable-year-navigation'"></mat-datepicker>
                    </mat-form-field>
                    <div class="_return_date_close">
                        <mat-form-field  appearance="outline" floatLabel="always" (click)="returnDatepicker.open()">
                            <mat-label>Return Date</mat-label>
                            <input class="returnDate" [max]="maxDate"  [min]="getReturnDateMinDate()" matInput [formControl]="returndate" placeholder="Savings with Round-Trip" [matDatepicker]="returnDatepicker" (dateChange)="onReturnDateChanged()" readonly>
                            <mat-icon class="date_picker_clear" matSuffix *ngIf="this.trip_selected.value === 1" (click)="CHANGE_ROUND_TRIP()">close</mat-icon>
                            <mat-datepicker-toggle  matSuffix [for]="returnDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker #returnDatepicker startView="month" [panelClass]="'disable-year-navigation'"></mat-datepicker>
                        </mat-form-field>
                    </div>
                </ng-container>
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Trip Selection</mat-label>
                    <mat-select [formControl]="prefclass">
                        <mat-option *ngFor="let item of booking_class" [value]="item.class">{{item.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="itinerary_passanger_class_">
                    <mat-form-field appearance="fill" floatLabel="always" (click)="passangerClass()">
                        <mat-label>Passenger</mat-label>
                        <div class="inputArea">
                            <input matInput [formControl]="numadults"  [ngModel]="adult_value_" readonly hidden>
                            <input matInput [formControl]="numchildren"  [ngModel]="child_value_" readonly hidden>
                            <input matInput [formControl]="numinfants"  [ngModel]="infants_value_" readonly hidden>
                            {{adult_value_ + child_value_ + infants_value_}} Traveller
                        </div>
                    </mat-form-field>
                </div>
                <button mat-button class="modify"   color="primary" (click)="modifyFlightSearch()" [disabled]="(this.adult_value_ < this.infants_value_ || this.infants_value_ + this.child_value_ + this.adult_value_ > 9) || !formModified  || isSameCity()">{{buttonModify}}</button> <!-- || isSearchButtonDisabled-->
            </div>
            <mat-error class="mtError" *ngIf="isSameCity()"><strong>*Traveller From & To</strong> cannot be same city.</mat-error>
        </form>
    </ng-container>
    
    <ng-container (clickOutside)="passangerClassOutside($event)" *ngIf="isShow">
        <div class="passanger_booking_class_" (click)="$event.stopPropagation()">
            <section class="passanger_count_section_">
                <!-- <h3>No of Traveller</h3> -->
                <div class="wrapper_passanger_">
                        <div class="inner_wrapper_">
                            <div class="content">
                                <h4 [ngClass]="{denger: this.adult_value_ === 9 || this.infants_value_ + this.child_value_ + this.adult_value_ > 9}">Adults</h4>
                                <p>(Ages 12 yrs or above)</p>
                                <div class="count_num_">
                                <button mat-mini-fab class="count_btn_" (click)="adult_decr_()" [disabled]="isDisabledAdlt_Decr">-</button>
                                <p class="num_">{{this.adult_value_}}</p>
                                <button mat-mini-fab class="count_btn_" (click)="adult_incr_()" [disabled]="isDisabledAdlt_Inc">+</button>
                            </div>
                        </div>
                    </div>
                    <div class="inner_wrapper_">
                        <div class="content">
                            <h4 [ngClass]="{denger: this.child_value_ === 9 || this.infants_value_ + this.child_value_ + this.adult_value_ > 8}">Children</h4>
                            <p>(Ages 2-12 yrs)</p>
                          <div class="count_num_">
                            <button mat-mini-fab class="count_btn_" (click)="child_decr_()" [disabled]="isDisabledChild_Decr">-</button>
                            <p class="num_">{{child_value_}}</p>
                            <button mat-mini-fab class="count_btn_" (click)="child_incr_()" [disabled]="isDisabledChild_Inc">+</button>
                        </div>
                    </div>
                </div>
                <div class="inner_wrapper_">
                    <div class="content">
                          <h4 [ngClass]="{denger: this.infants_value_ === 9 || this.infants_value_ + this.child_value_ + this.adult_value_ > 9}">Infants</h4>
                          <p>(Under 2 yrs)</p>
                          <div class="count_num_">
                              <button mat-mini-fab class="count_btn_" (click)="Infa_decr_()" [disabled]="isDisabledInfa_Decr">-</button>
                              <p class="num_">{{this.infants_value_}}</p>
                              <button mat-mini-fab class="count_btn_" (click)="Infa_incr_()" [disabled]="isDisabledInfa_Inc">+</button>
                            </div>
                        </div>
                    </div>
                </div>
                <mat-error class="infanterror" *ngIf="this.adult_value_ < this.infants_value_" >*Number of infants cannot be more than adults.</mat-error>
            </section>
            <section class="booking_footer_message_" *ngIf="this.infants_value_ + this.child_value_ + this.adult_value_ > 9">
                <h3>Looking to make a booking for more than 9 people?</h3>
                <p>Use our group booking feature for better discounts!</p>
                <button mat-button class="secoundaryBtn">Get a call back</button>
              </section>
              <section class="booking_footer_" *ngIf="this.infants_value_ + this.child_value_ + this.adult_value_ < 9">
                <button mat-button (click)="CancelReset()">Cancel</button>
                <button mat-stroked-button color="primary" [disabled]="isDisabledApplyBtn" (click)="Applybtn()">Apply</button>
            </section>
        </div>
    </ng-container>
</div>